import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

//My Contract.js

export const submitMyContractCall = async (reqBody) => interceptor(async () => client.post(urls.submitMyContract, await substituteEncrypted(reqBody), getHeader()));

export const getActiveCancellationCases = async (reqBody) =>
  interceptor(async () => client.post(urls.getActiveCancellationCases, await substituteEncrypted(reqBody), getHeader()));
